import { Typography } from '@material-ui/core'

import useCancelStyles from '../CancelPoliciesList/styles/PoliciesTable.styles'
import { AddOnPolicyRowProps } from './AddOnPolicyRow'
import { AddOnPolicyRowMenu } from './AddOnPolicyRowMenu'
import { formatCutoff } from './formatCutoff'
import { useAddOnPolicyRowActions } from './useAddOnPolicyRowActions'

const AddOnPolicyRowMobile: React.FC<AddOnPolicyRowProps> = ({
  data,
  providerCode,
  canEdit,
  canDelete
}) => {
  const classes = useCancelStyles()
  const { openTable, openDelete, dialogs } = useAddOnPolicyRowActions(
    data,
    providerCode
  )

  return (
    <>
      <div className={classes.tableRowMobile}>
        <div className={classes.nameCell}>
          <Typography variant="h4">{data.basicDetails.name}</Typography>
          <Typography variant="caption" color="textSecondary">
            {formatCutoff(data.cutoffHours)}
          </Typography>
        </div>
        <div>
          <AddOnPolicyRowMenu
            id={data.basicDetails.id}
            providerCode={providerCode}
            canEdit={canEdit}
            canDelete={canDelete}
            openTable={openTable}
            openDelete={openDelete}
          />
        </div>
      </div>
      {dialogs}
    </>
  )
}

export default AddOnPolicyRowMobile
